<template>
  <el-drawer
    :visible.sync="visible"
    :title="title"
    :direction="direction"
    :fullscreen="fullscreen"
    :show-close="showHeaderClose"
    v-bind="$attrs"
    :size="size"
    @close="onClose"
  >
    <div class="dy-drawer">
      <div class="drawer-content">
        <slot />
      </div>
      <div v-if="showFooter" class="drawer-footer">
        <slot name="footer">
          <el-button
            v-if="showConfirm"
            :loading="loading"
            :disabled="loading"
            type="primary"
            icon="el-icon-check"
            @click="onConfirm"
          >{{ confirmTitle }}
          </el-button>
          <el-button v-if="showCancel" icon="el-icon-close" @click="onClose">取 消</el-button>
        </slot>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'DyDrawer',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '30%'
    },
    direction: {
      type: String,
      default: 'rtl'
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    showHeaderClose: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '900px'
    },
    confirmTitle: {
      type: String,
      default: '保 存'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fullscreen: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onClose() {
      this.visible = false
      this.$emit('onClose')
    },
    onConfirm() {
      this.$emit('onConfirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.dy-drawer {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px;
  .drawer-content {
    flex: 1;
    overflow: auto;
  }
  .drawer-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

::v-deep {

  .el-drawer .el-drawer__header {
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    padding: 15px;
    margin-bottom: 0;
  }
}

</style>
